/*
 *
 * Dashboard reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_AMBASSADOR_PROFILE_WATCHER,
  GET_AMBASSADOR_PROFILE_SUCCESS,
  GET_DASHBOARD_SUCCESS,
  GET_DASHBOARD_WATCHER,
  GET_TASK_SUCCESS,
} from "./constants"

export const initialState = fromJS({
  loading_profile: true,
  profile_ambassador: {
    plans: [],
    ambassador: {},
  },
  pending_surveys: [],
  isLoadingFileHistores: undefined,
  loading_dashboard: true,
  dashboard: {
    measure_with_measure_metrics: [],
    surveys_type: [],
    active_tasks: [],
  },
})

function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case GET_AMBASSADOR_PROFILE_WATCHER:
      return state
        .set("loading_profile", true)
        .set("profile_ambassador", {})
        .set("pending_surveys", [])
    case GET_AMBASSADOR_PROFILE_SUCCESS:
      return state
        .set("loading_profile", false)
        .set("profile_ambassador", {
          plans: action.payload.plans,
          ambassador: action.payload.ambassador,
        })
        .set("pending_surveys", action.payload.surveys)
    case GET_DASHBOARD_WATCHER:
      return state.set("loading_dashboard", true).set("dashboard", {
        measure_with_measure_metrics: [],
        surveys_type: [],
        active_tasks: [],
      })
    case GET_DASHBOARD_SUCCESS:
      return state
        .set("loading_dashboard", false)
        .set("dashboard", action.payload)
    case GET_TASK_SUCCESS:
      return state
        .set("profile_ambassador", {
          plans: action.payload.profile.plans,
          ambassador: action.payload.profile.ambassador,
        })
        .set("dashboard", action.payload.dashboard)
    default:
      return state
  }
}

export default dashboardReducer
